(() => {
  if (customElements.get('ahd-bag-builder')) return;
  class BagBuilder extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      try { this.data = JSON.parse(this.querySelector('[data-builder-data]').textContent); }
      catch { this.querySelector('[data-status]').textContent = 'The builder could not load. Please refresh the page.'; return; }
      this.step = 0; this.bag = null; this.variant = null; this.straps = []; this.busy = false;
      this.q = selector => this.querySelector(selector);
      this.money = cents => new Intl.NumberFormat(this.dataset.locale || 'en', {style:'currency',currency:this.dataset.currency || 'USD'}).format(cents / 100);
      this.q('[data-back]').addEventListener('click', () => this.go(-1));
      this.q('[data-next]').addEventListener('click', () => this.step === 3 ? this.add() : this.go(1));
      this.dialog = this.q('[data-color-dialog]');
      this.q('[data-dialog-close]').addEventListener('click', () => this.dialog.close());
      this.q('[data-dialog-add]').addEventListener('click', () => this.confirmStrap());
      this.dialog.addEventListener('close', () => {
        this.modalProduct = null;
        if (this.modalTrigger?.isConnected) this.modalTrigger.focus({preventScroll:true});
        else this.q('[data-step-title]').focus({preventScroll:true});
      });
      this.render();
    }
    recommendations() {
      const pairing = this.bag?.pairings?.find(p => String(p.variantId) === String(this.variant?.id));
      const entries = pairing ? pairing.straps : this.dataset.curatedOnly === 'true' ? [] : this.data.straps.map(product => ({product,preferredId:null}));
      const seen = new Set();
      return entries.filter(e => {
        if (!e.product) return false;
        const key = String(e.preferredId || e.product.id);
        if (seen.has(key)) return false;
        seen.add(key);
        return true;
      });
    }
    preferred(entry) {
      return entry.product.variants.find(v => String(v.id) === String(entry.preferredId) && v.available)
        || entry.product.variants.find(v => v.available) || entry.product.variants[0];
    }
    openColors(entry, trigger, replaceIndex = null) {
      if (this.busy) return;
      this.modalProduct = entry.product; this.modalTrigger = trigger; this.replaceIndex = replaceIndex;
      this.modalVariant = replaceIndex !== null ? this.straps[replaceIndex].variant : this.preferred(entry);
      this.q('[data-dialog-title]').textContent = entry.product.title;
      this.q('[data-dialog-status]').textContent = '';
      this.renderColors(); this.dialog.showModal();
      const target = this.q('[data-dialog-options] [aria-pressed="true"]') || this.q('[data-dialog-close]');
      target.focus({preventScroll:true});
    }
    renderColors() {
      const options = this.q('[data-dialog-options]'); options.replaceChildren();
      const first = this.modalVariant;
      const variants = [...this.modalProduct.variants].sort((a,b) => Number(b.id === first?.id) - Number(a.id === first?.id));
      for (const v of variants) options.append(this.card(this.picture(this.modalProduct,v),v.title === 'Default Title' ? 'Standard' : v.title,v.price,v.id === this.modalVariant?.id,!v.available,() => {
        this.modalVariant = v;
        // Keep focus and card order stable while updating the selected color.
        for (const card of options.children) card.setAttribute('aria-pressed',String(card.dataset.variantId === String(v.id)));
        this.updateModalButton(); this.q('[data-dialog-status]').textContent = v.title + ' selected.';
      }));
      Array.from(options.children).forEach((card,i) => card.dataset.variantId = String(variants[i].id));
      this.updateModalButton();
    }
    updateModalButton() {
      const alreadyAdded = this.straps.some((s,i) => s.variant.id === this.modalVariant?.id && i !== this.replaceIndex);
      const full = this.replaceIndex === null && this.straps.length >= 2;
      const add = this.q('[data-dialog-add]');
      add.disabled = !this.modalVariant?.available || alreadyAdded || full;
      add.textContent = alreadyAdded ? 'Already added' : full ? 'Three straps selected' : this.replaceIndex !== null ? 'Update strap' : 'Add strap';
    }
    confirmStrap() {
      if (this.q('[data-dialog-add]').disabled || !this.modalProduct || !this.modalVariant?.available) return;
      const item = {product:this.modalProduct,variant:this.modalVariant};
      if (this.replaceIndex !== null) this.straps[this.replaceIndex] = item;
      else if (this.straps.length < 2) this.straps.push(item);
      this.dialog.close(); this.render(); this.message(`${this.straps.length} of 2 straps selected.`);
    }
    picture(product, variant) {
      const image = variant?.featured_image;
      return (typeof image === 'string' ? image : image?.src) || product.featured_image || product.images?.[0] || '';
    }
    img(src, alt) {
      const img = document.createElement('img'); img.alt = alt; img.loading = 'lazy';
      if (src) { const url = new URL(src, location.origin); url.searchParams.set('width','700'); img.src = url.href; }
      return img;
    }
    name(product, variant) { return product.title + (variant && variant.title !== 'Default Title' ? ' — ' + variant.title : ''); }
    message(text) { this.q('[data-status]').textContent = text; }
    card(src, title, price, selected, disabled, onClick, disabledText = 'Unavailable') {
      const b = document.createElement('button'); b.type = 'button'; b.className = 'ahd-byb__card';
      b.setAttribute('aria-pressed', String(selected)); b.disabled = disabled;
      b.append(this.img(src, ''));
      for (const text of [title, disabled ? disabledText : this.money(price)]) { const s = document.createElement('span'); s.textContent = text; b.append(s); }
      b.addEventListener('click', onClick); return b;
    }
    permitted() { return !!this.variant?.available && (this.bag?.included || this.straps.length > 0); }
    go(delta) {
      if (this.busy) return;
      if (delta > 0 && ((this.step === 0 && !this.bag) || (this.step === 1 && !this.variant?.available) || (this.step === 2 && !this.permitted()))) return;
      this.step = Math.max(0, Math.min(3, this.step + delta)); this.render();
      this.q('[data-step-title]').focus({preventScroll:true});
      const heading = this.q('[data-step-title]');
      heading.style.scrollMarginTop = matchMedia('(max-width:767px)').matches
        ? 'calc(var(--byb-top) + 32svh + 24px)'
        : 'calc(var(--byb-top) + 24px)';
      heading.scrollIntoView({block:'start', behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
    }
    updateImage() {
      const img = this.q('[data-main-image]'); const src = this.bag ? this.picture(this.bag.product, this.variant) : '';
      img.hidden = !src; this.q('[data-placeholder]').hidden = !!src;
      if (src) { const url = new URL(src, location.origin); url.searchParams.set('width','1200'); img.src = url.href; img.alt = this.name(this.bag.product, this.variant); }
    }
    renderSlots() {
      const slots = this.q('[data-slots]'); slots.replaceChildren(); slots.hidden = this.step < 2;
      if (this.step < 2) return;
      for (let i = 0; i < 2; i++) {
        const box = document.createElement('div'); box.className = 'ahd-byb__slot';
        const selection = this.straps[i];
        if (selection) {
          box.append(this.img(this.picture(selection.product, selection.variant), this.name(selection.product, selection.variant)));
          const remove = document.createElement('button'); remove.type = 'button'; remove.textContent = 'Remove';
          remove.setAttribute('aria-label', 'Remove ' + this.name(selection.product, selection.variant));
          remove.addEventListener('click', () => { this.straps.splice(i,1); this.render(); this.message('Strap removed.'); this.q('[data-step-title]').focus({preventScroll:true}); });
          const edit = document.createElement('button'); edit.type = 'button'; edit.textContent = 'Change';
          edit.setAttribute('aria-label','Change color of ' + this.name(selection.product, selection.variant));
          edit.addEventListener('click', () => this.openColors({product:selection.product,preferredId:selection.variant.id},edit,i));
          box.append(edit,remove);
        } else box.textContent = 'Strap ' + (i+1);
        slots.append(box);
      }
    }
    render() {
      const titles = ['Choose your style','Choose your color','Add a strap','What’s included'];
      this.q('[data-step-title]').textContent = titles[this.step];
      const progress = this.q('[data-progress]'); progress.replaceChildren(); progress.setAttribute('aria-label', `Step ${this.step+1} of 4: ${titles[this.step]}`);
      titles.forEach((title,i) => { const bar = document.createElement('span'); bar.setAttribute('aria-label',title); if (i === this.step) bar.setAttribute('aria-current','step'); progress.append(bar); });
      const options = this.q('[data-options]'); options.replaceChildren(); options.hidden = this.step === 3;
      this.q('[data-summary]').replaceChildren(); this.message('');
      this.q('[data-help]').textContent = this.step === 2 ? `${this.straps.length} of 3 straps selected. ${this.bag?.included ? 'A matching strap is included. Extra straps are optional.' : 'This bag is sold without a strap. Choose at least one to complete your bag.'}` : this.step === 1 ? 'Choose an available color.' : '';
      if (this.step === 0) {
        for (const entry of this.data.bags) {
          const p = entry.product; const v = p.variants.find(v => v.available);
          options.append(this.card(this.picture(p,v),entry.label || p.title,v?.price ?? p.price,this.bag === entry,!v,() => { this.bag = entry; this.variant = null; this.straps = []; this.render(); this.message((entry.label || p.title) + ' selected.'); }));
        }
        if (!this.data.bags.length) this.message('Choose bag products in the theme editor to set up this builder.');
      } else if (this.step === 1 && this.bag) {
        for (const v of this.bag.product.variants) options.append(this.card(this.picture(this.bag.product,v),v.title === 'Default Title' ? 'Standard' : v.title,v.price,this.variant?.id === v.id,!v.available,() => { if (this.variant?.id !== v.id) this.straps = []; this.variant = v; this.render(); this.message(v.title + ' selected.'); }));
      } else if (this.step === 2) {
        const recommendations = this.recommendations();
        for (const entry of recommendations) {
          const p = entry.product; const v = this.preferred(entry);
          if (!v) continue;
          const selected = this.straps.some(s => s.variant.id === v.id);
          const full = this.straps.length >= 3;
          const card = this.card(this.picture(p,v),this.name(p,v),v.price,selected,!v.available || full,() => this.openColors(entry,card), full ? 'Two straps selected' : 'Unavailable');
          card.setAttribute('aria-haspopup','dialog');
          const hint = document.createElement('span'); hint.textContent = 'Choose color'; card.append(hint); options.append(card);
        }
        if (!recommendations.length) this.message(this.dataset.curatedOnly === 'true' ? 'No strap pairings are available for this color yet. Choose another bag color.' : 'No straps found. Check the strap collection setting.');
      } else if (this.step === 3 && this.bag && this.variant) {
        const summary = this.q('[data-summary]');
        for (const item of [{product:this.bag.product,variant:this.variant},...this.straps]) {
          const row = document.createElement('div'); row.className = 'ahd-byb__review'; row.append(this.img(this.picture(item.product,item.variant),''));
          const p = document.createElement('p'); p.textContent = this.name(item.product,item.variant) + ' · ' + this.money(item.variant.price); row.append(p); summary.append(row);
        }
        const note = document.createElement('p'); note.className = 'ahd-byb__note';
        note.textContent = (this.bag.included ? 'A matching strap is included with your bag. ' : '') + 'Eligible promotions apply in your cart. Shipping and taxes are calculated at checkout.'; summary.append(note);
      }
      this.renderSlots(); this.updateImage();
      const total = (this.variant?.price || 0) + this.straps.reduce((sum,s) => sum + s.variant.price,0);
      this.q('[data-total]').textContent = this.variant ? 'Subtotal ' + this.money(total) : '';
      this.q('[data-back]').hidden = this.step === 0;
      this.q('[data-next]').textContent = this.step === 3 ? 'Add to cart' : 'Next';
      this.q('[data-next]').disabled = this.step === 0 ? !this.bag : this.step === 1 ? !this.variant?.available : !this.permitted();
    }
    async add() {
      if (this.busy || !this.permitted()) return;
      this.busy = true; this.q('[data-next]').disabled = true; this.q('[data-next]').textContent = 'Adding…'; this.q('[data-back]').disabled = true;
      const root = window.Shopify?.routes?.root || '/';
      const items = [this.variant,...this.straps.map(s => s.variant)].map(v => ({id:v.id,quantity:1}));
      try {
        const response = await fetch(root + 'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items})});
        const result = await response.json();
        if (!response.ok) throw new Error(typeof result.description === 'string' ? result.description : 'One or more selections are unavailable. Review your cart before trying again.');
        window.location.assign(root + 'cart');
      } catch (error) {
        this.busy = false; this.q('[data-next]').disabled = false; this.q('[data-next]').textContent = 'Add to cart'; this.q('[data-back]').disabled = false;
        this.message(error.message + ' If the connection was interrupted, check your cart before retrying.');
      }
    }
  }
  customElements.define('ahd-bag-builder', BagBuilder);
})();
